<div class="blue-background" style="min-height: 200px">
  <div class="lemon-table-container">
    <div class="lemon-table" id="tuotteet" style="width: 100%; font-size: 0.8rem">
      <div class="valkoinen lemon-header-row">
        <div class="tuotteet_nimi lemon-header-cell">{{ 'lasku.tuote-lemonator' | translate | async }}</div>
        <div class="tuotteet_lisatiedot lemon-header-cell">{{ 'lasku.tuote-lisatiedot' | translate | async }}</div>
        <div class="tuotteet_maara lemon-header-cell">{{ 'lasku.maara' | translate | async }}</div>
        <div class="tuotteet_ahinta lemon-header-cell">{{ 'lasku.a-hinta-veroton' | translate | async }}</div>
        <div class="tuotteet_alv lemon-header-cell">{{ 'lasku.alv-kanta' | translate | async }}</div>
        <div class="tuotteet_ale lemon-header-cell">{{ 'lasku.ale-pros' | translate | async }}</div>
        <div class="tuotteet_yhteensa lemon-header-cell">{{ 'lasku.tuote-yhteensa-veroton' | translate | async }}</div>
        <div class="tuotteet_poista lemon-header-cell"></div>
      </div>

      @for (tuote of parent.tuotteet; track tuote; let i = $index) {
        <app-lasku-rivi [parent]="tuote" [alvt]="alvtObservable | async" [laskunKieli]="laskunKieli" [paivitaValidaatiot]="paivitaValidaatiot" (validaatioMuuttuiTapahtuma)="validaatioMuuttuiTapahtumakuuntelija($event, i)" (riviPoistettuTapahtuma)="rivinPoistamisenKuuntelija($event)"> </app-lasku-rivi>
      }
    </div>

    @if (onkoVirhe(parent.tuotteet, 'min')) {
      <div class="lemon-error" style="margin-top: 10px">
        {{ 'lasku.validation.tuotteet.min' | translate | async }}
      </div>
    }

    <app-lemonaid-primary-button (click)="lisaaLaskunRivi()" actionId="Avaa uusi laskurivi" styles="padding: 0 1rem 0 .5rem; border: 1px rgb(255,255,255) solid; margin-top:20px; margin-bottom:20px;" matIcon="add">
      {{ 'lasku.lisaa-rivi' | translate | async }}
    </app-lemonaid-primary-button>

    @if ((virheetObservable | async)?.length > 0) {
      <div class="lemon-error" style="margin-bottom: 30px">
        @for (virhe of virheetObservable | async; track virhe; let i = $index) {
          <div>
            @if (virhe?.virheet) {
              <div>
                {{ 'lasku.validation.rivin-alku' | translate: { rivi_nro: i + 1 } | async }}
                @for (err of virhe?.virheet; track err) {
                  <span>
                    {{ 'lasku.validation.' + err.field + '.' + err.error | translate | async }}
                  </span>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    <div>
      <app-lemonaid-primary-button mat-button (click)="lisaaLiite()" actionId="Valitse tiedosto: Lisää laskun liitetiedosto" styles="border: 1px rgb(255,255,255) solid; color: white; padding: 0 1rem 0 .5rem; margin: 0;" matIcon="add">
        {{ 'lasku.lisaa-liite' | translate | async }}
      </app-lemonaid-primary-button>

      @if (kuvavirheAvain()) {
        <div class="red-text" style="padding: 2vh 3vh 2em 2em">{{ kuvavirheAvain() | translate: kuvavirheParametrit() | async }}</div>
      }

      @if (parent.liitetiedostot().value().length > 0) {
        <div style="padding-top: 20px">
          <mat-chip-listbox>
            @for (liite of parent.liitetiedostot; track liite; let i = $index) {
              <mat-chip-option style="height: unset" [removable]="true" (removed)="poistaLiitetiedosto(liite().value(), i)">
                <div style="display: flex; flex-flow: wrap; width: 100%">
                  <div style="display: flex; flex-flow: nowrap; width: 100%; justify-content: space-between">
                    @if (liite().value().uploadDone) {
                      <div>{{ liite().value().nimi }}</div>
                    }
                    @if (!liite().value().uploadDone) {
                      <div>{{ 'lasku.ladataan' | translate | async }} {{ liite().value().nimi }}...</div>
                    }
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </div>
                  @if (!liite().value().uploadDone) {
                    <div style="width: 100%; padding: 10px 0">
                      <mat-progress-bar mode="determinate" [value]="liite().value().uploadDonePercentage" style="width: calc(100% - 25px)"></mat-progress-bar>
                    </div>
                  }
                  @if (liite().value().uploadError) {
                    <div class="error-text" style="width: calc(100% - 25px); padding: 10px 0">{{ 'lasku.tiedoston-lahettaminen-epaonnistui-alku' | translate | async }} "{{ annaVirheteksti(liite().value().uploadError) }}". {{ 'lasku.tiedoston-lahettaminen-epaonnistui-loppu' | translate | async }}</div>
                  }
                </div>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      }
    </div>
  </div>

  <!-- <div *ngIf="isDraggingObservable | async">
  <app-file-drop #droppi dropZoneClassName="laskun-rivit-liitetiedosto-drop-container"
    (onFileOver)="fileOver($event)"
    (onFileLeave)="fileLeave($event)"
    (onFileDrop)="fileDrop($event)"
    class="laskun-liitetiedostot-droppi"
    >
    <ng-template app-file-drop-content-tmp>
      <div class="laskun-rivit-liitetiedosto-drop-laatikko">
        <div style="text-align: center;">
          <div>{{'lasku.raahaa-tanne' | translate | async}}</div>
          <div style="font-size: .9rem; padding-top: 1.5em;">{{'lasku.tuetut-tiedostot' | translate | async}}</div>
        </div>
      </div>
    </ng-template>
  </app-file-drop>
</div> -->
</div>

<input style="visibility: hidden; height: 1px" (change)="fileChanged($event)" type="file" accept="image/*,application/pdf" #fileInput multiple="multiple" />
